module.exports = __webpack_public_path__ + "images/98e3d6f5b64ae370089749117d607a98-living_office.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content/living_office.jpg
// module id = ./src/assets/images/content/living_office.jpg
// module chunks = 0